window.addEventListener('DOMContentLoaded', checkIfAllInstancesOfVariantAddedToCart);

export function checkIfAllInstancesOfVariantAddedToCart() {
  const forms = document.querySelectorAll('.product-form');
  forms.forEach((form) => {
    const button = form.querySelector('.add-to-cart-button');
    const formData = new FormData(form);
    const productData = {};
    formData.forEach((value, key) => (productData[key] = value));

    setAllProductsInCartAttribute(productData, button);
  });
}

async function setAllProductsInCartAttribute(productData, button) {
  if ((!productData, !button)) return;
  const availableCount = button.dataset.totalAvailable;
  const cart = await Shopify.functions.getCart();
  button.setAttribute('all-products-in-cart', false);
  if ((!availableCount, !cart)) return;

  let allProductsInCart = false;
  cart.items.forEach((item) => {
    if (item.variant_id == productData.id && item.quantity >= availableCount) {
      allProductsInCart = true;
    }
  });

  if (!allProductsInCart) return;
  button.setAttribute('all-products-in-cart', true);
}

export default checkIfAllInstancesOfVariantAddedToCart;
